export const mediaStrings = {
  mobile: "mobile",
  tablet: "tablet",
  desktop: "desktop"
};

